/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SearchBusinessMemoriesRequestBody = {
  /**
   * Exact content-scope tag to match.
   */
  contentScope?: string | undefined;
  /**
   * Content-scope namespace to match.
   */
  contentScopeNamespace?: string | undefined;
  /**
   * Maximum search results.
   */
  limit?: number | undefined;
  /**
   * Natural-language semantic search query.
   */
  query: string;
};

/** @internal */
export type SearchBusinessMemoriesRequestBody$Outbound = {
  content_scope?: string | undefined;
  content_scope_namespace?: string | undefined;
  limit: number;
  query: string;
};

/** @internal */
export const SearchBusinessMemoriesRequestBody$outboundSchema: z.ZodMiniType<
  SearchBusinessMemoriesRequestBody$Outbound,
  SearchBusinessMemoriesRequestBody
> = z.pipe(
  z.object({
    contentScope: z.optional(z.string()),
    contentScopeNamespace: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    query: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentScope: "content_scope",
      contentScopeNamespace: "content_scope_namespace",
    });
  }),
);

export function searchBusinessMemoriesRequestBodyToJSON(
  searchBusinessMemoriesRequestBody: SearchBusinessMemoriesRequestBody,
): string {
  return JSON.stringify(
    SearchBusinessMemoriesRequestBody$outboundSchema.parse(
      searchBusinessMemoriesRequestBody,
    ),
  );
}
